import { Variables } from './../../../styles/variables'
import styled from "styled-components";

export const Container = styled.div`
.btn-filter {
    button {
        background: #516274;
        color: #FFF;
        border-radius: 8px;
        margin-bottom: 16px;
    }
}

.show-initiative-summary-modal {
    .modal-content {
        padding: 0px !important;

        .modal-header {
            display: flex;
            justify-content: right;
            text-align: right !important;

            .icon,
            .modal-title {
                display: none;
            }

            .btn-modal-close {
                margin: 5px 10px 0 0;
            }
        }

        .modal-body {
            .modal-description {
                margin-bottom: 0px !important;
            }

            .initiative-resume {
                border: unset;
            }
        }

        .modal-footer {
            display: none;
        }
    }
}

.companies {
    min-height: calc(100vh - 102px);

    .title {
        display: flex;

        .text {
            font-weight: 600;
            font-size: 24px;
            line-height: 32px;
        }

        hr {
            border: 0.5px solid #516274;
            width: 100%;
            margin-left: 21px;
        }
    }

    .cards {
        margin-top: 25px;
        margin-bottom: 35px;

        .card-btn {
            display: none;
        }

        .card {
            cursor: pointer;
            min-height: 68px;
            background: rgba(243, 243, 243, 0.9);
            opacity: 0.95;
            padding: 8px 16px;
            border-radius: 12px;
            border: unset;
            margin-top: 25px;

            .info {
                .name {
                    font-weight: 600;
                    font-size: 22px;
                    line-height: 28px;
                    margin-bottom: 4px;
                }

                .address {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    letter-spacing: 0.1px;
                }
            }

            .type-status {
                position: relative;
                background: ${Variables.gray};
                margin-top: 0px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding: 0px;
                width: 140px;
                height: 40px;
                border: 1px solid #516274;
                border-radius: 50px;

                .type {
                    cursor: pointer;
                    color: #fff;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 20px;
                    letter-spacing: 0.1px;
                    padding: 10px 16px;
                    z-index: 11;
                }

                .bg-type {
                    position: absolute;

                    &.status {
                        box-shadow: 0 8px 18px rgba(81, 98, 116, 0.12);
                        border-radius: 50px;
                        height: 40px;
                        
                        &.inactive {
                            background: #F4C600;
                            left: -3px;
                            min-width: 82px;
                            transition: all 0.7s ease-in-out;
                        }
                        
                        &.active {
                            background: ${Variables.success};
                            left: 72px;
                            min-width: 76px;
                            transition: all 0.7s ease-in-out;
                        }
                    }
                }
            }

            .status {
                display: flex;

                &.active {
                    .circle {
                        background-color: ${Variables.success};
                    }

                    .text {
                        color: ${Variables.success};
                    }
                }

                &.inactive {
                    .circle {
                        background-color: ${Variables.danger};
                    }

                    .text {
                        color: ${Variables.danger};
                    }
                }

                .circle {
                    height: 24px;
                    width: 24px;
                    border-radius: 50%;
                    display: inline-block;
                }

                .text {
                    margin-left: 16px;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0.1px;
                }
            }
        }
    }
}

.modal {
    .modal-dialog {
        width: 312px;
        .modal-content {
            padding: 24px;
            width: unset;
        }
    }
}

.initiative-home {
    margin-top: 20px;
    margin-bottom: 8px;

    .stats-row {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 12px;
        margin-bottom: 16px;
    }

    .stat-card {
        background: rgba(243, 243, 243, 0.95);
        border-radius: 14px;
        padding: 16px 18px;
        display: flex;
        flex-direction: column;
        gap: 6px;

        .stat-label {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            color: #516274;
        }

        strong {
            font-size: 28px;
            line-height: 1;
            color: #1C1B1F;
        }

        &.accent {
            background: rgba(244, 198, 0, 0.28);
        }
    }

    .partnership-panels {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;
    }

    .panel {
        background: #FFF;
        border: 1px solid #D9DEE5;
        border-radius: 16px;
        padding: 16px;

        .panel-head {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 12px;
            color: #516274;

            h4 {
                margin: 0;
                font-size: 15px;
                font-weight: 700;
                color: #1C1B1F;
            }
        }

        .panel-subhead {
            margin: 14px 0 10px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            color: #79747E;
        }

        .panel-empty {
            font-size: 13px;
            color: #79747E;
            line-height: 1.4;
            padding: 8px 0;
        }
    }

    .partner-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 10px;
        border-radius: 12px;
        background: #F7F8FA;
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }

        &.accepted {
            background: rgba(0, 103, 104, 0.08);
        }

        &.pending {
            background: rgba(244, 198, 0, 0.14);
        }

        .partner-main {
            display: flex;
            align-items: center;
            gap: 10px;
            min-width: 0;

            img {
                width: 36px;
                height: 36px;
                border-radius: 10px;
                object-fit: cover;
                background: #FFF;
                flex-shrink: 0;
            }

            strong {
                display: block;
                font-size: 14px;
                color: #1C1B1F;
            }

            span {
                display: block;
                font-size: 12px;
                color: #79747E;
            }

            .tag {
                display: inline-flex;
                margin-top: 2px;
                padding: 2px 8px;
                border-radius: 999px;
                background: rgba(0, 103, 104, 0.12);
                color: #006768;
                font-weight: 600;

                &.pending {
                    background: rgba(244, 198, 0, 0.35);
                    color: #516274;
                }
            }
        }

        .partner-actions {
            display: flex;
            gap: 6px;
            flex-shrink: 0;

            button {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                border-radius: 100px;
                padding: 7px 10px;
                font-size: 12px;
                font-weight: 600;
                cursor: pointer;
                border: 1px solid transparent;
            }

            .accept,
            .reject {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                min-height: 36px;
                border-radius: 100px;
                padding: 8px 16px;
                font-size: 13px;
                font-weight: 600;
                letter-spacing: 0.1px;
                cursor: pointer;
                border: 1px solid transparent;
                color: #516274;

                svg {
                    display: block;
                    flex-shrink: 0;
                    width: 16px;
                    height: 16px;
                    color: #516274;
                    stroke: #516274;
                }
            }

            .accept {
                background: #F4C600;
                border-color: #F4C600;
                box-shadow: 0 6px 14px rgba(81, 98, 116, 0.16);

                &:hover {
                    background: #e0b500;
                    border-color: #e0b500;
                }
            }

            .reject {
                background: #FFF;
                border-color: rgba(81, 98, 116, 0.45);

                &:hover {
                    background: rgba(81, 98, 116, 0.08);
                }
            }
        }
    }
}

.cards {
    .card.initiative-card {
        .extra-meta {
            margin-top: 8px;

            > span {
                display: block;
                font-size: 13px;
                color: #516274;
                margin-bottom: 4px;
            }

            p {
                margin: 0 0 8px;
                font-size: 13px;
                line-height: 1.4;
                color: #79747E;
            }

            .mini-stats {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                span {
                    background: rgba(244, 198, 0, 0.25);
                    color: #516274;
                    border-radius: 999px;
                    padding: 3px 10px;
                    font-size: 12px;
                    font-weight: 600;
                }
            }
        }
    }
}

.all-filter-modal {
    overflow: unset;

    .modal-dialog {
        margin-top: 25px;
        width: auto;

        .modal-content {
            padding: unset;

            .modal-body {
                max-height: calc(100vh - 170px);
                overflow-y: auto;
            }

            .modal-footer {
                box-shadow: 0px -4px 0px rgba(0, 0, 0, 0.12);
            }
        }
    }
}

@media (max-width: 991.98px) {
    .initiative-home {
        .stats-row,
        .partnership-panels {
            grid-template-columns: 1fr;
        }
    }
}

@media (max-width: 575.99px) {
    .show-initiative-summary-modal {
        .modal-content {
            padding: 0px !important;
        }
    }

    .companies {
        .cards {
            .card {
                .type-status {
                    margin: 12px 0px;
                }
            }
        }
    }

    .initiative-home {
        .partner-row {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    .all-filter-modal {
        .modal-dialog {
            margin-top: 0px;
        }
    }
}
`